// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartLinesListHeaderStyles } from "@bg/Overrides/Components/CartLinesListHeader";
import { fontConfig } from "@bg/XDL/PreStyle/typography";
import { xScreen } from "@bg/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

cartLinesListHeaderStyles.productCountText = {
    variant: "h2",
    css: css`
        margin-bottom: 0;
    `,
};

cartLinesListHeaderStyles.saveOrderLink = {
    typographyProps: {
        size: fontConfig.fontSize.regular,
        lineHeight: fontConfig.lineHeight.regular,
        css: css`
            color: ${getColor("text.main")} !important;
        `,
    },
    icon: {
        iconProps: {
            src: "SystemUpdate",
            size: 16,
            color: "tertiary.main",
            css: css`
                svg {
                    fill: ${getColor("tertiary.main")};
                }
            `,
        },
    },
    css: css`
        align-items: baseline;
        ${IconWrapper} {
            display: block;
            top: 1px;
            position: relative;
        }
    `,
};

cartLinesListHeaderStyles.addAllToListLink = {
    css: css`
        &&:hover svg path,
        &&:focus svg path {
            d: path(
                "M 14.65 0 C 12.72 0 11.02 0.87 10 2.19 C 8.98 0.87 7.28 0 5.35 0 C 2 0 0 2.87 0 5.65 c 0 6.31 9.11 11.67 9.5 11.9 l 0.5 0.29 l 0.5 -0.29 c 0.39 -0.23 9.5 -5.59 9.5 -11.9 C 20 2.48 17.65 0 14.65 0 Z M 10 5.06 L 10 5.06 L 10 5.06 L 10 5.06 Z"
            ) !important;
        }

        margin-left: auto;
        ${xScreen("lte", 500)} {
            margin-left: 0;
        }

        align-items: baseline;
        ${IconWrapper} {
            display: block;
            top: 1px;
            position: relative;
        }
    `,
    typographyProps: {
        size: fontConfig.fontSize.regular,
        lineHeight: fontConfig.lineHeight.regular,
        css: css`
            color: ${getColor("text.main")} !important;
        `,
    },
    icon: {
        iconProps: {
            src: "ProductListStroked",
            size: 16,
            color: "tertiary.main",
        },
    },
};

cartLinesListHeaderStyles.cartLink = {
    css: css`
        && {
            color: ${getColor("text.main")} !important;
            line-height: ${fontConfig.lineHeight.regular};
            font-size: ${fontConfig.fontSize.regular}px;
        }
    `,
};
